<template>
  <b-container fluid>
    <b-row no-gutters class="bordered-box-header align-items-center">
      <h2>{{pageTitle}}</h2>
    </b-row>
    <b-row no-gutters class="bordered-box">
      <b-form @submit.prevent="onSubmit" class="col-12">
        <b-form-group class="required" label="Nazwa">
          <b-form-input
            v-model="name"
            :state="$v.name.$error? false : null"
            @input="$v.name.$reset()"
            type="text"
            autocomplete="off"
          />
          <b-form-invalid-feedback>
            <div v-if="!$v.name.required">To pole jest wymagane</div>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group class="required" label="Poziom zaawansowania">
          <b-form-select
            v-model="languageProficiency"
            :options="languageProficiencies"
            :state="$v.languageProficiency.$error? false : null"
          ></b-form-select>
          <b-form-invalid-feedback>
            <div v-if="!$v.languageProficiency.required">To pole jest wymagane</div>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group class="required" label="Opis">
          <b-form-textarea
            v-model="description"
            :state="$v.description.$error? false : null"
            @input="$v.description.$reset()"
            rows="6"
            max-rows="6"
            autocomplete="off"
          />
          <b-form-invalid-feedback>
            <div v-if="!$v.description.required">To pole jest wymagane</div>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group class="text-right">
          <hr />
          <b-button
            type="submit"
            variant="primary"
            class="mr-1"
            :disabled="saving"
            @click="$v.$touch"
          >
            <span v-show="!saving">Zapisz</span>
            <span v-show="saving">
              <b-spinner small label="Proszę czekać..."></b-spinner>
            </span>
          </b-button>
          <b-button class="mr-1" variant="secondary" @click="$router.go(-1)">Powrót</b-button>
          <b-button variant="link" @click="goToDetails" v-if="courseId">Szczegóły</b-button>
        </b-form-group>
      </b-form>
    </b-row>
  </b-container>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      saving: false,
      name: null,
      courseId: this.id,
      description: null,
      languageProficiency: null,
      languageProficiencies: [
        { value: null, text: "" },
        { value: 0, text: this.$options.filters.languageProficiency(0) },
        { value: 1, text: this.$options.filters.languageProficiency(1) },
        { value: 6, text: this.$options.filters.languageProficiency(6) },
        { value: 2, text: this.$options.filters.languageProficiency(2) },
        { value: 3, text: this.$options.filters.languageProficiency(3) },
        { value: 4, text: this.$options.filters.languageProficiency(4) },
        { value: 5, text: this.$options.filters.languageProficiency(5) }
      ]
    };
  },
  computed: {
    pageTitle() {
      if (this.courseId) {
        return "Edycja kursu";
      } else {
        return "Utwórz nowy kurs";
      }
    }
  },
  props: ["id"],
  validations: {
    name: { required },
    languageProficiency: { required },
    description: { required }
  },
  mounted() {
    if (this.id) {
      let loader = this.$loading.show({
        container: this.$refs.mainContainer
      });
      axios
        .get("/templatecourses/edit", {
          params: {
            id: this.id
          }
        })
        .then(response => {
          var result = response.data;

          this.courseId = result.id;
          this.name = result.name;
          this.description = result.description;
          this.languageProficiency = result.languageProficiency;
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          loader.hide();
        });
    }
  },
  methods: {
    goToDetails() {
      this.$router.push({ path: `/site/courses/details/${this.courseId}` });
    },
    onSubmit() {
      if (!this.$v.$error) {
        this.saving = true;

        axios[this.courseId ? "put" : "post"]("/templatecourses", {
          id: this.courseId,
          name: this.name,
          description: this.description,
          languageProficiency: this.languageProficiency
        })
          .then(response => {
            var result = response.data;

            this.courseId = result.id;
            this.name = result.name;
            this.description = result.description;
            this.languageProficiency = result.languageProficiency;

            eventBus.$emit("notify-success", "Zapisano poprawnie.");
          })
          .catch(error => eventBus.$emit("unhandled-error", error))
          .then(() => (this.saving = false));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.bordered-box-header {
  margin-top: 20px;
  padding: 10px;
  margin-bottom: 0px;
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.bordered-box {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 10px;
}
</style>